<ion-accordion-group class="purchase-limits-bar" #accordionGroup>
  <!-- ? Header -->
  <ion-grid
    fixed
    [ngStyle]="{
      'background-color': 'var(--ion-color-' + statusColorBG + ')'
    }"
    class="limits-header"
    [ngClass]="{ 'limits-header-edit': remainingTime.length > 0 }"
  >
    <ion-row class="ion-align-items-center ion-justify-content-between">
      <!-- * Icono de carrito -->
      <ion-col size="1.2" class="ion-no-padding">
        <ion-icon
          [name]="cartIcon"
          [color]="statusColorFill"
          class="status-icon"
        >
        </ion-icon>
      </ion-col>

      <!-- * Título - subtítulo - info -->
      <ion-col size="10.6" class="ion-no-padding">
        <ion-item
          mode="md"
          color="transparent"
          lines="none"
          class="item-bullets"
        >
          <ion-label
            color="getm-neutral-dark"
            [innerHTML]="
              'Miscellaneous.purchase-limits.status.' + purchaseStatus
                | translate
                | htmlSeguro
            "
            class="status-title"
          >
          </ion-label>

          <getm-tag-card-img
            icon="getm-information-outline"
            iconColor="getm-neutral-dark"
            color="statusColorBG"
            shape="round"
            size="small"
            (tagClick)="toggleAccordion()"
          ></getm-tag-card-img>
        </ion-item>

        <!-- * Barra de progreso -->
        <ion-range
          #targetRange
          mode="md"
          [value]="progressPercentage"
          [max]="100"
          [color]="statusColorFill"
          class="progress-range"
          [ngClass]="{
            'progress-range-0': progressPercentage < 1,
            'progress-range-100': progressPercentage >= 100
          }"
        >
        </ion-range>

        <!-- * Edición Pedido -->
        <ng-container *ngIf="remainingTime.length > 0">
          <section class="edit-section">
            <getm-special-info
              iconColor="getm-neutral-light"
              [text]="'Labels.edit-until' | translate"
              textColor="getm-neutral-light"
              [remainingTime]="remainingTime"
              [backgroundColor]="statusColorBG"
            ></getm-special-info>
          </section>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- ? Accordion -->
  <ion-accordion
    [value]="'limits'"
    [disabled]="false"
    class="getm-accordion-no-icon"
    toggleIcon="getm-information-outline"
    [ngStyle]="{
      'background-color': 'var(--ion-color-' + statusColorBG + ')'
    }"
  >
    <ion-item slot="header" class="accordion-header"> </ion-item>

    <ion-item-group slot="content" class="limits-header">
      <ion-item
        mode="md"
        lines="none"
        [color]="statusColorBG"
        class="item-bullets ion-text-center"
      >
        <ion-label color="getm-neutral-dark" class="guarantee-delivery">
          {{ 'Labels.guarantee-delivery' | translate }}
        </ion-label>
      </ion-item>

      <ng-container *ngFor="let label of limitsOrderDisclaimers">
        <ng-container *ngIf="label.active">
          <ion-item
            mode="md"
            [color]="statusColorBG"
            lines="none"
            class="item-bullets"
          >
            <ion-icon
              slot="start"
              name="ellipse-sharp"
              [color]="label.point"
              class="icon-bullets"
            ></ion-icon>

            <ion-label
              [color]="label.point"
              class="disclaimers"
              [innerHTML]="label.disclaimer | htmlSeguro"
            >
            </ion-label>
          </ion-item>
        </ng-container>
      </ng-container>
    </ion-item-group>
  </ion-accordion>
</ion-accordion-group>
